import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './layout.css';
import App from './App';
import { App as AntApp } from 'antd';
import { StorageProvider } from './contexts/StorageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root') as HTMLElement;

// ErrorBoundary 가 없는 앱이라 모듈 로드 중 throw 는 흰 화면이 된다 — env 가 없으면 앱 대신
// 원인을 화면에 보여 준다. 실제 방어선은 prebuild(scripts/check-env.js)로, 빌드 단계에서 막는다.
// CRA 는 env 가 없으면 process.env.REACT_APP_API_URL 을 문자열 "undefined" 로 인라인할 수 있어
// (2026-10-19 리뷰) 그 경우도 미설정으로 본다.
const apiUrl = process.env.REACT_APP_API_URL;
if (!apiUrl || apiUrl === 'undefined' || apiUrl === '') {
  rootElement.textContent =
    'REACT_APP_API_URL 이 설정되지 않아 앱을 시작할 수 없습니다 — .env.production(개발: .env.development.local)을 확인해 주세요.';
  rootElement.style.padding = '24px';
  rootElement.style.fontFamily = 'sans-serif';
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <StorageProvider>
        <ThemeProvider>
          <AntApp>
            <App />
          </AntApp>
        </ThemeProvider>
      </StorageProvider>
    </React.StrictMode>
  );

  reportWebVitals();
}